import React from "react";
import { Route, Switch } from "react-router-dom";
import { ChakraProvider, Box } from "@chakra-ui/react";
import Stats from "./views/Stats";
import All from "./views/All";
import HeaderV3 from "./components/Header/HeaderV3";
import { HeaderTabs } from "./components/AppHeader";
import { ChainProvider, useChain } from "./hooks/useChain";
import customTheme from "./theme";

import "./App.css";

const Layout = ({ children }) => (
  <Box pt={"64px"}>
    <HeaderV3 />
    <HeaderTabs />
    <div className="content">{children}</div>
  </Box>
);

const ChainLayout = ({ children }) => {
  const { chainName } = useChain();

  return <div>{chainName ? <Layout>{children}</Layout> : null}</div>;
};

const App = () => {
  return (
    <Switch>
      <ChakraProvider theme={customTheme}>
        <div className="App">
          <Route exact path="/">
            <div>
              <Layout>
                <All />
              </Layout>
            </div>
          </Route>
          <Route exact path="/:chain">
            <ChainProvider>
              <ChainLayout>
                <Stats />
              </ChainLayout>
            </ChainProvider>
          </Route>
        </div>
      </ChakraProvider>
    </Switch>
  );
};

export default App;
